import React from 'react'
import { css, StyleSheet } from "aphrodite";

function ExportCSV({data, fileName}) {
  function downloadCSV() {
      const headers = [
        'Sr. No.',
        'Created At',
        'Product Code',
        'Product Name',
        'Category',
        'Collection Name',
        'Finish',
        'Tags',
        'Features'
      ];
    
      const escapeCSV = (value) => {
        if (typeof value === 'string') {
          value = value.replace(/"/g, '""'); // escape quotes
          if (value.includes(',') || value.includes('\n') || value.includes('\r')) {
            return `"${value}"`;
          }
        }
        return value ?? '';
      };
    
      const rows = data.map((item, index) => [
        index + 1,
        item.updatedAt || '',
        item.productCode || '',
        item.name || '',
        item.category || '',
        item.collectionName || '',
        item.finish || '',
        Array.isArray(item.tags) ? item.tags.join(', ') : '',
        item.features || ''
      ]);
    
      const csvContent = [
        headers.join(','),
        ...rows.map(row => row.map(escapeCSV).join(','))
      ].join('\n');
    
      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
      const url = URL.createObjectURL(blob);
    
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    
    
  }
  
      
  return (
    <button className={css(styles.exportButton)}  onClick={downloadCSV}>Export Product Data CSV</button>
  )
}

export default ExportCSV

const styles = StyleSheet.create({
  exportButton: {
    backgroundColor: '#02142b',
    color: "white",
    border: "none",
    fontSize: "0.95em",
    padding: "6px 10px",
    borderRadius: "4px",
    cursor: "pointer",
    boxShadow: "0 3px 8px #cccccc",
  },
})